import {Component, OnInit} from '@angular/core';
import {User} from '../../../classes/user';
import {UserService} from '../../../services/user';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {RoleService} from '../../../services/role';
import {Role} from '../../../classes/role';
import {Pa} from "../../../classes/pa";
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";
import {PaService} from "../../../services/pa";

@Component({
    selector: 'app-user-create',
    templateUrl: './user-create.component.html',
    styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {

    user = new User();
    userCreationResult = true;
    roles: Array<Role> = [];
    pas: Array<Pa> = [];

    constructor(private router: Router,
                private userService: UserService,
                private roleService: RoleService,
                private paService: PaService) {
    }

    ngOnInit(): void {
        this.user.fk_id_role = 1;
        this.roleService.getAll()
            .subscribe({
                next: (roles: any) => {
                    this.roles = roles;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });

        this.paService.getAll()
            .pipe(
                switchMap((pasData: any) => from(pasData))
            )
            .subscribe({
                next: (pa: any) => {
                    this.pas.push(pa);
                },
                error: e => {
                    console.log('Error: ' + e);
                }
            });
    }

    onSubmit() {
        this.userService.create(this.user)
            .subscribe({
                next: () => {
                    this.router.navigate(['/user']);
                },
                error: (err: HttpErrorResponse) => {
                    this.userCreationResult = false;
                    console.log(err);
                }
            });
    }

}
